import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { Profile, ProfileModelService } from '../profile/profile-model.service';
import { ProfileService } from '../profile/profile.service';
@Injectable()
export class AzureProfileGuard implements CanActivate {
  constructor (private authService: MsalService, private profileService: ProfileService, private profileModelService: ProfileModelService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve) => {
      const userClaims = this.authService.instance.getAllAccounts()[0] as any;
      const isAuthenticated = !!userClaims;

      if (isAuthenticated) {
        if (!this.profileModelService.isAuthenticated) {

          this.profileService.updateUserName(this.getUserEmail(userClaims) , userClaims.name).subscribe(
            (profileData: Profile) => {
              this.profileModelService.profile = profileData;
              resolve(true);
            },
            (error) => {
              this.profileService.get(this.getUserEmail(userClaims)).subscribe(
                (profileData) => {
                  this.profileModelService.profile = profileData;
                  resolve(true);
                }
              );
            }
          );
        } else {
          resolve(true);
        }
      } else {
        resolve(false);
      }
    });
  }

  private getUserEmail(user): string {
    if(user.idTokenClaims != null){
      return user.idTokenClaims.email || user.idTokenClaims.preferred_username;
    }
    return user.username;
  }

}
